/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

export default function List({ items, title }) {
  return (
    <div>
      {title && (
        <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6 flex justify-between w-full">
          {title}
        </h2>
      )}
      <ul className="space-y-2">
        {items?.map?.((item) => {
          return (
            <li
              key={item.key}
              className="bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 p-4"
            >
              {item.content}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
